import { Circle, CircleAlert, CircleCheck } from 'lucide-react';
import { GetPackNameColorProps } from '../../../types/orderProductPacksMenu.types';

export const getPackNameColor = ({ isPackSelected, isPackWithError }: GetPackNameColorProps) => {
  if (isPackWithError && isPackSelected) {
    return 'error';
  }
  if (isPackSelected) {
    return 'primary';
  }
  return 'textSecondary';
};

export const getPackStatusIcon = ({ isPackSelected, isPackWithError }: GetPackNameColorProps) => {
  if (isPackWithError && isPackSelected) {
    return { icon: CircleAlert, color: 'error.main' };
  }
  if (isPackSelected) {
    return { icon: CircleCheck, color: 'primary.main' };
  }
  return { icon: Circle, color: 'action.disabled' };
};
